/*
 * @Description:
 * @Autor: lwq
 * @Date: 2020-07-14 10:23:41
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2020-09-24 16:33:53
 * @FilePath: \mrc-base-server-view\src\store\getters.js
 */
const getters = {
  userData(state) {
    return state.userData
  },
  cpage(state) {
    return state.cpage
  },
  lang_name(state) {
    const lang = state.currentCompanyLanguage.filter((item) => {
      return item.value.toLowerCase() == state.lang.toLowerCase()
    })
    let text = ""
    if (lang.length > 0) {
      text = lang[0].text
    }
    return text
  },
  lang(state) {
    if (
      !state.currentCompanyLanguage.some((item) => item.value == state.lang)
    ) {
      if (state.currentCompanyLanguage.length > 0)
        return state.currentCompanyLanguage[0].value
    }
    return state.lang
  },
  btnPermission: (state) => state.btnPermission,
  pubk: (state) => state.pubk,
  menuFunctionUuid: (state) => state.menuFunctionUuid,
  subPage_name(state) {
    const arr = state.subPage_name
    if (!arr) return ""
    const type = Object.prototype.toString.call(arr)
    if (type.indexOf("String") > -1) {
      return arr
    }
    let newArr = []
    if (type.indexOf("Array") > -1 && arr.length <= 0) {
      return ""
    }
    arr.forEach((item, index) => {
      newArr.push({})
      for (let i in item) {
        if (item[i] && i != "uuid") {
          newArr[index][i] = item[i]
        }
      }
    })
    const keys = newArr.map((item) => {
      return Object.keys(item)[0]
    })
    const values = newArr.map((item) => {
      return Object.values(item)[0]
    })
    const currentLanguageIndex = keys.findIndex((item) => item == state.lang)
    return values[currentLanguageIndex]
  },
}

export default getters
